<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import { required } from "vuelidate/lib/validators";
import Multiselect from 'vue-multiselect';
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/es';
import moment from 'moment';


import { categories } from "./data-calendar";

const TODAS_LAS_SEDES = 'Todas las sedes';

/**
 * Calendar component
 */
export default {
    components: { FullCalendar, Multiselect, DatePicker, moment },
    data() {
        return {
            title: "Calendar",
            items: [
                {
                text: "Calendar",
                active: true
                }
            ],
            eventTimeFormat: { // like '14:30:00'
                hour: '2-digit',
                minute: '2-digit'
            },
            calendarWeekends: true,
            calendarPlugins: [
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                bootstrapPlugin,
                listPlugin
            ],
            themeSystem: "bootstrap",
            calendarEvents: [],
            showModal: false,
            eventModal: false,
            categories: categories,
            submitted: false,
            submit: false,
            newEventData: {},
            edit: {},
            deleteId: {},
            event: {
                user_id:'',
                title: '',
                category: '',
                servicio:'',
                profesional:'',
                hora:'',
                fecha:''
            },
            editevent: {
                user_id:'',
                title: '',
                category: '',
                servicio:'',
                profesional:'',
                hora:'',
                fecha:''
            },
            validations: {
                event: {
                    user_id: {required},
                    servicio: {required},
                    profesional: {required},
                    hora: {required}
                },
            },
            usersOptions:[],
            serviciosOptions:[],
            profesionalOptions:[],
            tipos:[],
            subtipos:[],
            copiado:false,
            sede: TODAS_LAS_SEDES,
            sedes:[TODAS_LAS_SEDES, 'Santiago', 'Viña del Mar', 'Concepción'],
            coordinador: [],
            allCoordinadores: [],
            coordinadores:[],
            calendarEventsFiltrados:[],
            isSmallScreen: window.innerWidth < 768,
            tooltip: { visible: false, ev: {}, x: 0, y: 0 }
        };
    },
    computed: {
        // Mostrar día en móviles y mes en escritorio
        initialView() {
            return this.isSmallScreen ? 'timeGridDay' : 'dayGridMonth';
        },
        sedeFiltrable() {
            return this.sede && !this.esOpcionTodasLasSedes(this.sede) ? this.sede : '';
        },
        coordinadorFiltrable() {
            if (!Array.isArray(this.coordinador)) {
                return [];
            }

            return this.deduplicarValores(this.coordinador);
        }
    },
    validations: {
        event: {
            title: { required },
            category: { required }
        }
    },
    watch: {
        sede() {
            this.actualizarCoordinadores();
            this.filtrarEventos();
        },
        coordinador: {
            handler() {
                this.filtrarEventos();
            },
            deep: true,
        },
       // Cambiar vista del calendario cuando cambie el tamaño de pantalla
        isSmallScreen(newVal, oldVal) {
            if (newVal === oldVal) return;
            const view = newVal ? 'timeGridDay' : 'dayGridMonth';
            this.setCalendarView(view);
        }
    },
    mounted(){
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos
            this.subtipos=res.data.subtipos
        });

    },
    methods: {
        formatearNombreEvento(evento) {
            const base = (evento?.nombre_difusion || evento?.title || '').toString().trim();
            const comentario = (evento?.comentario_nombre_evento || '').toString().trim();
            if (!base) return comentario || '';
            return comentario ? `${base} (${comentario})` : base;
        },
        setCalendarView(view) {
            // intenta obtener la API de fullcalendar y cambiar la vista
            try {
                const api = this.$refs.fullCalendar && this.$refs.fullCalendar.getApi && this.$refs.fullCalendar.getApi();
                if (api && typeof api.changeView === 'function') {
                    api.changeView(view);
                }
            } catch (e) {
                // silencioso: puede ejecutarse antes de que el calendario esté inicializado
                console.warn('setCalendarView:', e);
            }
        },
        async copiarLink(link) {
            try {
                await navigator.clipboard.writeText(link);
                this.copiado = true;
                this.$toasted.success('Link Copiado');
                setTimeout(() => (this.copiado = false), 2000);
            } catch (err) {
                this.$toasted.error("Error al copiar: ", err);
            }
        },
        /**
         * Modal form submit
         */
        labelselect ({ name }) {
            return `${name}`
        },
        /**
         * Modal open for edit event
         */
        editEvent(info) { //mostrara info del evento
            if (info.jsEvent && (info.jsEvent.ctrlKey || info.jsEvent.metaKey)) {
                info.jsEvent.preventDefault();
                this.ver_evento(info.event.extendedProps.codigo, info.jsEvent);
                return;
            }

            this.edit = info.event;
            this.editevent = this.edit.extendedProps;
            this.eventModal = true;
        },
        closeModal() {
            this.eventModal = false;
        },
        get_data(){
            this.isLoading = true;
            Promise.all([
                axios.get('/api/get_proximos_eventos'),
                axios.get('/api/get_coordinadores_calendario')
            ]).then(([eventosRes, coordinadoresRes]) => {
                this.calendarEvents = eventosRes.data.eventos || [];
                this.calendarEventsFiltrados = [...this.calendarEvents];
                this.allCoordinadores = coordinadoresRes.data.coordinadores || [];
                this.sedes = this.construirOpcionesSede();
                this.aplicarFiltroInicialUsuario();
                this.actualizarCoordinadores();
                this.filtrarEventos();
            }).catch(e => {
                this.isLoading = false;
            });
        },
        ver_evento(evento, browserEvent = null){
            localStorage.setItem('evento_codigo',evento);

            if (browserEvent && (browserEvent.ctrlKey || browserEvent.metaKey)) {
                window.open('/web/configuracion/eventos', '_blank');
                return;
            }

            window.location.href = "/web/configuracion/eventos";
        },
        normalizarTexto(valor) {
            return (valor || '')
                .toString()
                .trim()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();
        },
        esEventoCancelado(evento) {
            return this.normalizarTexto(evento && evento.estado_actividad) === 'cancelado';
        },
        aplicarEstiloEventos(lista) {
            return (lista || []).map((evento) => {
                const eventoConEstilo = { ...evento };
                const classNamesBase = Array.isArray(eventoConEstilo.classNames)
                    ? [...eventoConEstilo.classNames]
                    : [];

                if (this.esEventoCancelado(eventoConEstilo)) {
                    if (!classNamesBase.includes('evento-cancelado')) {
                        classNamesBase.push('evento-cancelado');
                    }

                    eventoConEstilo.classNames = classNamesBase;
                    eventoConEstilo.backgroundColor = '#8f9bad';
                    eventoConEstilo.borderColor = '#7b8799';
                    eventoConEstilo.textColor = '#ffffff';

                    return eventoConEstilo;
                }

                eventoConEstilo.classNames = classNamesBase.filter((item) => item !== 'evento-cancelado');

                return eventoConEstilo;
            });
        },
        esOpcionTodasLasSedes(valor) {
            return this.normalizarTexto(valor) === this.normalizarTexto(TODAS_LAS_SEDES);
        },
        deduplicarValores(lista) {
            return [...new Map(
                lista
                    .map(item => (item || '').toString().trim())
                    .filter(item => item !== '')
                    .map(item => [this.normalizarTexto(item), item])
            ).values()];
        },
        construirOpcionesSede() {
            const sedesBase = ['Santiago', 'Viña del Mar', 'Concepción'];
            const sedesEventos = this.calendarEvents.map(evento => evento.sede_asociada);
            const sedesCoordinadores = this.allCoordinadores.map(item => item.sede);
            const sedesDisponibles = this.deduplicarValores([...sedesBase, ...sedesEventos, ...sedesCoordinadores])
                .filter(sede => this.normalizarTexto(sede) !== 'general');

            return [
                TODAS_LAS_SEDES,
                ...sedesDisponibles
            ];
        },
        construirOpcionesCoordinador(lista) {
            const nombres = this.deduplicarValores(
                lista.map(item => typeof item === 'string' ? item : item && item.nombre)
            );

            return nombres;
        },
        aplicarFiltroInicialUsuario() {
            if (!this.user) {
                this.sede = TODAS_LAS_SEDES;
                this.coordinador = [];
                return;
            }

            if (this.user.rol === 'Coordinador') {
                this.coordinador = this.user.name ? [this.user.name] : [];
                return;
            }

            if (this.user.rol === 'Supervisor') {
                this.sede = this.user.sede || '';
                this.actualizarCoordinadores();
                return;
            }

            this.sede = TODAS_LAS_SEDES;
            this.coordinador = [];
        },
        filtrarEventos() {
            let eventosFiltrados = this.calendarEvents;
            if (this.sedeFiltrable) {
                const sedeSeleccionada = this.normalizarTexto(this.sedeFiltrable);
                eventosFiltrados = eventosFiltrados.filter(evento => this.normalizarTexto(evento.sede_asociada) === sedeSeleccionada);
            }
            if (this.coordinadorFiltrable.length > 0) {
                const coordinadoresSeleccionados = this.coordinadorFiltrable.map(coordinador => this.normalizarTexto(coordinador));
                eventosFiltrados = eventosFiltrados.filter(evento => coordinadoresSeleccionados.includes(this.normalizarTexto(evento.coordinador_evento)));
            }
            this.calendarEventsFiltrados = this.aplicarEstiloEventos(eventosFiltrados);
        },
        actualizarCoordinadores() {
            if (this.sedeFiltrable) {
                const sedeSeleccionada = this.normalizarTexto(this.sedeFiltrable);
                const coordinadoresDesdeEventos = this.calendarEvents
                    .filter(evento => this.normalizarTexto(evento.sede_asociada) === sedeSeleccionada)
                    .map(evento => ({ nombre: evento.coordinador_evento }));

                if (coordinadoresDesdeEventos.length > 0) {
                    this.coordinadores = this.construirOpcionesCoordinador(coordinadoresDesdeEventos);
                } else {
                    const coordinadoresCatalogo = this.allCoordinadores.filter(c => this.normalizarTexto(c.sede) === sedeSeleccionada);
                    this.coordinadores = this.construirOpcionesCoordinador(coordinadoresCatalogo);
                }
            } else {
                this.coordinadores = this.construirOpcionesCoordinador(this.allCoordinadores);
            }

            this.coordinador = this.coordinadorFiltrable.filter(coordinador => this.coordinadores.includes(coordinador));

            if (this.user && this.user.rol === 'Coordinador' && this.user.name && this.coordinadores.includes(this.user.name) && this.coordinador.length === 0) {
                this.coordinador = [this.user.name];
            }
        },
        handleResize() {
            this.isSmallScreen = window.innerWidth < 768;
        },
        _removeTooltip() {
            const existing = document.getElementById('udla-cal-tooltip');
            if (existing) existing.remove();
        },
        onEventMouseEnter(info) {
            this._removeTooltip();

            const ev = info.event.extendedProps || {};
            const nombreEvento = this.formatearNombreEvento({
                ...ev,
                title: info.event.title || '',
            });
            const coordinadorACargo = ev.propietario || ev.propietario_colegio || '—';
            const coordinadorEvento = ev.coordinador_evento || '—';
            const numeroAsistentes = ev.num_asistentes ?? 0;

            const rect = info.el.getBoundingClientRect();
            let x = rect.left;
            let y = rect.bottom + 8;

            if (x + 280 > window.innerWidth) x = window.innerWidth - 288;
            if (y + 295 > window.innerHeight) y = rect.top - 301;

            const div = document.createElement('div');
            div.id = 'udla-cal-tooltip';
            div.style.cssText = `position:fixed;left:${x}px;top:${y}px;z-index:99999;pointer-events:none;width:270px;font-family:inherit;`;
            div.innerHTML = `
                <div style="background:#fff;border-radius:10px;box-shadow:0 8px 32px rgba(203,151,0,.24);overflow:hidden;animation:udlaTooltipIn .15s ease;border:1px solid rgba(203,151,0,.18);">
                    <div style="background:#2a3042;padding:10px 14px;">
                        <p style="margin:0;font-size:10px;color:rgba(255,255,255,.8);text-transform:uppercase;letter-spacing:.05em;">Evento</p>
                        <p style="margin:0;font-weight:700;color:#fff;font-size:13px;line-height:1.3;">${nombreEvento}</p>
                    </div>
                    <div style="padding:10px 14px;">
                        ${ev.codigo ? `<div style="display:flex;align-items:center;margin-bottom:5px;"><span style="color:#CB9700;margin-right:6px;">&#128196;</span><span style="font-size:11px;color:#6c757d;font-family:monospace;letter-spacing:.03em;">${ev.codigo}</span></div>` : ''}
                        <div style="display:flex;align-items:center;margin-bottom:5px;">
                            <span style="color:#CB9700;margin-right:6px;">&#127968;</span>
                            <span style="font-size:12px;color:#252C5F;">${ev.colegio || '—'}</span>
                        </div>
                        <div style="display:flex;align-items:flex-start;margin-bottom:5px;">
                            <span style="color:#CB9700;margin-right:6px;">&#128100;</span>
                            <div>
                                <p style="margin:0;font-size:10px;color:#6c757d;text-transform:uppercase;letter-spacing:.04em;">Coordinador a cargo</p>
                                <span style="font-size:12px;color:#252C5F;">${coordinadorACargo}</span>
                            </div>
                        </div>
                        <div style="display:flex;align-items:flex-start;">
                            <span style="color:#CB9700;margin-right:6px;">&#128188;</span>
                            <div>
                                <p style="margin:0;font-size:10px;color:#6c757d;text-transform:uppercase;letter-spacing:.04em;">Coordinador</p>
                                <span style="font-size:12px;color:#252C5F;">${coordinadorEvento}</span>
                            </div>
                        </div>
                        <div style="display:flex;align-items:center;margin-top:5px;">
                            <span style="color:#CB9700;margin-right:6px;">&#128101;</span>
                            <span style="font-size:12px;color:#252C5F;"><strong>N° Asistentes:</strong> ${numeroAsistentes}</span>
                        </div>
                    </div>
                    <div style="padding:4px 14px 8px;border-top:1px solid rgba(203,151,0,.16);">
                        <span style="font-size:11px;color:#6c757d;">&#128432; Clic para ver detalles</span>
                    </div>
                </div>`;

            document.body.appendChild(div);
        },
        onEventMouseLeave() {
            this._removeTooltip();
        },
        async descargarEventos(tipoPeriodo) {
            return this.runDownload(`descargar_eventos_${tipoPeriodo}`, async () => {
                const ahora = new Date();
                const params = new URLSearchParams({
                    tipo_periodo: tipoPeriodo,
                    anio: String(ahora.getFullYear()),
                    mes: String(ahora.getMonth() + 1)
                });

                if (this.sedeFiltrable) {
                    params.append('sede', this.sedeFiltrable);
                }
                this.coordinadorFiltrable.forEach((coordinador) => {
                    params.append('coordinadores[]', coordinador);
                });

                if (this.coordinadorFiltrable.length === 1) {
                    params.append('coordinador', this.coordinadorFiltrable[0]);
                }

                try {
                    const response = await axios.get('/api/export_eventos_calendario?' + params.toString(), {
                        responseType: 'blob'
                    });

                    const contentType = (response.headers['content-type'] || '').toLowerCase();
                    const esExcel = contentType.includes('spreadsheetml') || contentType.includes('application/vnd.ms-excel') || contentType.includes('application/octet-stream') || contentType.includes('text/csv');
                    if (!esExcel) {
                        const textoError = await response.data.text();
                        let mensaje = 'No se pudo generar el archivo.';
                        try {
                            const json = JSON.parse(textoError);
                            mensaje = json.mensaje || json.message || mensaje;
                        } catch (e) {
                            if (textoError && textoError.trim().length) {
                                mensaje = textoError;
                            }
                        }
                        throw new Error(mensaje);
                    }

                    const blob = new Blob([
                        response.data
                    ], {
                        type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });

                    let fileName = `eventos_${tipoPeriodo}_${ahora.getFullYear()}_${ahora.getMonth() + 1}.xlsx`;
                    const disposition = response.headers['content-disposition'] || '';
                    const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
                    if (match && match[1]) {
                        fileName = match[1].replace(/['"]/g, '');
                    }

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                } catch (error) {
                    this.$toasted.error(error.message || 'No se pudo descargar el archivo.');
                }
            }, {
                message: 'Se esta generando el archivo. Esto puede tardar unos segundos.'
            });
        }
    },
    mounted() {
        this.get_data();
       // asegurar vista inicial correcta al montar
       this.$nextTick(() => this.setCalendarView(this.initialView));
    },
    created(){
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
        this._removeTooltip();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        this._removeTooltip();
    },
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card calendar-filter-card">
                    <div class="calendar-filter-head">
                        <i class="mdi mdi-calendar-month calendar-filter-head__icon"></i>
                        <span>Próximos eventos</span>
                    </div>
                    <div class="card-body calendar-filter-body">
                        <div class="calendar-filter-surface">
                            <div class="calendar-filter-surface__accent"></div>
                            <div class="calendar-filter-grid">
                                <div class="calendar-filter-field">
                                    <label class="calendar-filter-label">Sede</label>
                                    <multiselect
                                        v-model="sede"
                                        :options="sedes"
                                        placeholder="Todas las sedes"
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                    >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="calendar-filter-field">
                                    <label class="calendar-filter-label">Coordinador</label>
                                    <multiselect
                                        v-model="coordinador"
                                        :options="coordinadores"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Seleccionar coordinador"
                                        selectLabel="Presiona para seleccionar"
                                        selectedLabel="Seleccionado"
                                        deselectLabel="Presiona para remover"
                                    >
                                        <template v-slot:noOptions>
                                            <p>No hay opciones</p>
                                        </template>
                                        <template v-slot:noResult>
                                            <p>No se encuentra coincidencia</p>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="calendar-filter-action">
                                    <b-button class="calendar-filter-button" block @click="filtrarEventos">
                                        <i class="mdi mdi-filter-variant mr-1"></i>Filtrar
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 text-right pb-3">
                <div class="text-left text-muted mb-2">
                    Eventos filtrados: {{ calendarEventsFiltrados.length }}
                </div>
                <b-button variant="outline-primary" class="mr-2" @click="descargarEventos('mensual')" :disabled="isDownloadLoading('descargar_eventos_mensual')">
                    <b-spinner small class="mr-2" v-if="isDownloadLoading('descargar_eventos_mensual')"></b-spinner>
                    {{ getDownloadLabel('descargar_eventos_mensual', 'Descargar Excel mensual', 'Generando Excel mensual...') }}
                </b-button>
                <b-button variant="primary" @click="descargarEventos('anual')" :disabled="isDownloadLoading('descargar_eventos_anual')">
                    <b-spinner small class="mr-2" v-if="isDownloadLoading('descargar_eventos_anual')"></b-spinner>
                    {{ getDownloadLabel('descargar_eventos_anual', 'Descargar Excel anual', 'Generando Excel anual...') }}
                </b-button>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <!-- <b-button variant="primary" class="mb-3" >Descargar Eventos</b-button> -->
                        <div class="app-calendar">
                            <FullCalendar
                                ref="fullCalendar"
                                :initialView="initialView"
                                locale= "es"
                                :firstDay='1'
                                :buttonText="{ today:'Hoy', month:'Mes', week:'Semana',day:'Dia',list:'Lista' }"
                                :header="{ left: 'prev,next today',center: 'title',right: 'dayGridMonth,timeGridWeek,timeGridDay' }"
                                :editable="false"
                                :droppable="false"
                                :plugins="calendarPlugins"
                                :events="calendarEventsFiltrados"
                                :weekends="calendarWeekends"
                                :theme-system="themeSystem"
                                :eventTimeFormat="eventTimeFormat"
                                @eventClick="editEvent"
                                @eventMouseEnter="onEventMouseEnter"
                                @eventMouseLeave="onEventMouseLeave"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edit Modal -->
        <b-modal
        v-model="eventModal"
        hide-header
        hide-footer
        centered
        body-class="p-0"
        content-class="modal-udla"
        >
            <div class="d-flex align-items-center px-4 py-3 modal-udla-header">
                <i class="mdi mdi-calendar-check font-size-22 text-white mr-2"></i>
                <div class="flex-grow-1">
                    <h6 class="mb-0 text-white font-weight-bold">Información del Evento</h6>
                    <small class="text-white modal-udla-header-code">{{ editevent.codigo }}</small>
                </div>
                <button type="button" class="btn-close-udla" @click="closeModal">
                    <i class="mdi mdi-close"></i>
                </button>
            </div>

            <div class="px-4 py-3">
                <div class="mb-3 p-3 rounded modal-udla-actividad">
                    <p class="mb-0 font-size-13 text-muted text-uppercase font-weight-bold modal-udla-label">Actividad</p>
                    <p class="mb-0 font-size-15 font-weight-bold modal-udla-value-primary">{{ formatearNombreEvento(editevent) }}</p>
                </div>

                <div class="row">
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">Fecha Inicio</p>
                        <p class="mb-3 font-size-13 modal-udla-value-primary">
                            <i class="mdi mdi-calendar-arrow-right mr-1 modal-udla-icon"></i>{{ editevent.fecha_inicio }}
                        </p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">Fecha Término</p>
                        <p class="mb-3 font-size-13 modal-udla-value-primary">
                            <i class="mdi mdi-calendar-arrow-left mr-1 modal-udla-icon"></i>{{ editevent.fecha_termino }}
                        </p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">RBD</p>
                        <p class="mb-3 font-size-13 modal-udla-value-primary">
                            <i class="mdi mdi-identifier mr-1 modal-udla-icon"></i>{{ editevent.rbd_colegio }}
                        </p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">Colegio</p>
                        <p class="mb-3 font-size-13 modal-udla-value-primary">
                            <i class="mdi mdi-school mr-1 modal-udla-icon"></i>{{ editevent.colegio }}
                        </p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">Sede Asociada</p>
                        <p class="mb-3 font-size-13 modal-udla-value-primary">
                            <i class="mdi mdi-map-marker mr-1 modal-udla-icon"></i>{{ editevent.sede_asociada || '—' }}
                        </p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">Propietario Colegio</p>
                        <p class="mb-3 font-size-13 modal-udla-value-primary">
                            <i class="mdi mdi-account mr-1 modal-udla-icon"></i>{{ editevent.propietario_colegio || '—' }}
                        </p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">Coordinador Evento</p>
                        <p class="mb-0 font-size-13 modal-udla-value-primary">
                            <i class="mdi mdi-account-tie mr-1 modal-udla-icon"></i>{{ editevent.coordinador_evento || '—' }}
                        </p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1 font-size-11 text-uppercase text-muted font-weight-bold">N° Asistentes</p>
                        <p class="mb-0 font-size-13 modal-udla-value-primary">
                            <i class="mdi mdi-account-group mr-1 modal-udla-icon"></i>{{ editevent.num_asistentes ?? 0 }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-end px-4 pb-3" style="gap:8px;">
                <button class="btn btn-udla-light" @click="closeModal">
                    <i class="mdi mdi-close mr-1"></i>Cerrar
                </button>
                <button class="btn btn-udla-primary" @click="ver_evento(editevent.codigo, $event)">
                    <i class="mdi mdi-arrow-right mr-1"></i>Ir al Evento
                </button>
            </div>
        </b-modal>
    </div>
</template>

<style>
@keyframes udlaTooltipIn {
    from { opacity: 0; transform: translateY(-4px); }
    to { opacity: 1; transform: translateY(0); }
}

.modal-udla {
    border: 0;
    border-radius: 10px;
    overflow: hidden;
}

.modal-udla-header {
    background: #2a3042;
}

.modal-udla-header-code {
    opacity: .85;
}

.btn-close-udla {
    border: 0;
    background: rgba(255,255,255,.18);
    color: #fff;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.btn-close-udla:hover {
    background: rgba(255,255,255,.28);
}

.modal-udla-actividad {
    background: #fff6ea;
    border-left: 4px solid #CB9700;
}

.modal-udla-label {
    letter-spacing: .05em;
}

.modal-udla-value-primary {
    color: #7a4a00;
}

.modal-udla-icon {
    color: #CB9700;
}

.btn-udla-light {
    background: #fff6ea;
    color: #7a4a00;
    border: 1px solid rgba(203,151,0,.25);
}

.btn-udla-light:hover {
    background: #ffe9c7;
    color: #6a3f00;
}

.btn-udla-primary {
    background: #2a3042;
    color: #fff;
    border: 0;
}

.btn-udla-primary:hover {
    background: #222738;
    color: #fff;
}

.app-calendar .fc-event,
.app-calendar .fc-event:hover,
.app-calendar .fc-daygrid-event,
.app-calendar .fc-daygrid-event:hover,
.app-calendar .fc-timegrid-event,
.app-calendar .fc-timegrid-event:hover {
    cursor: pointer !important;
}

.app-calendar .fc-event.evento-cancelado,
.app-calendar .fc-daygrid-event.evento-cancelado,
.app-calendar .fc-timegrid-event.evento-cancelado {
    opacity: 0.42;
}

.app-calendar .fc-event.evento-cancelado:hover,
.app-calendar .fc-daygrid-event.evento-cancelado:hover,
.app-calendar .fc-timegrid-event.evento-cancelado:hover {
    opacity: 0.5;
}

.calendar-filter-card {
    overflow: visible;
    border: 1px solid rgba(201, 126, 55, 0.12);
    border-radius: 0.45rem;
    box-shadow: 0 14px 34px rgba(201, 126, 55, 0.08);
}

.calendar-filter-head {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    padding: 0.9rem 1.25rem;
    background: linear-gradient(90deg, #b86a2f 0%, #cc7d39 52%, #e2a058 100%);
    color: #fff;
    font-size: 1rem;
    font-weight: 800;
}

.calendar-filter-head__icon {
    font-size: 1rem;
}

.calendar-filter-body {
    padding: 1.25rem;
}

.calendar-filter-surface {
    position: relative;
    overflow: visible;
    padding: 1.2rem 1.2rem 1.2rem 1.45rem;
    border-radius: 0.85rem;
    background: #fff;
    border: 1px solid #edf0f5;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}

.calendar-filter-surface__accent {
    position: absolute;
    left: 0;
    top: 1rem;
    bottom: 1rem;
    width: 4px;
    border-radius: 999px;
    background: #cc7d39;
}

.calendar-filter-grid {
    display: grid;
    grid-template-columns: minmax(0, 1.2fr) minmax(0, 1.05fr) 200px;
    gap: 1rem;
    align-items: end;
}

.calendar-filter-field {
    min-width: 0;
}

.calendar-filter-label {
    display: block;
    margin-bottom: 0.45rem;
    color: #31384c;
    font-size: 0.95rem;
    font-weight: 800;
}

.calendar-filter-button {
    min-height: 44px;
    border: 0;
    border-radius: 0.55rem;
    background: #cc7d39 !important;
    color: #fff !important;
    font-weight: 800;
    box-shadow: 0 12px 24px rgba(204, 125, 57, 0.18);
}

.calendar-filter-button:hover,
.calendar-filter-button:focus {
    background: #bb6f2f !important;
    color: #fff !important;
}

.calendar-filter-card :deep(.multiselect) {
    min-height: 44px;
    z-index: 30;
}

.calendar-filter-card :deep(.multiselect--active) {
    z-index: 40;
}

.calendar-filter-card :deep(.multiselect__tags) {
    min-height: 44px;
    border-radius: 0.55rem;
    border-color: rgba(204, 125, 57, 0.34);
    box-shadow: none;
    background: #fff;
}

.calendar-filter-card :deep(.multiselect__select)::before {
    border-color: #9a6a45 transparent transparent;
}

.calendar-filter-card :deep(.multiselect__input),
.calendar-filter-card :deep(.multiselect__single),
.calendar-filter-card :deep(.multiselect__placeholder) {
    font-size: 0.95rem;
}

.calendar-filter-card :deep(.multiselect__content-wrapper) {
    z-index: 50;
}

@media (max-width: 991px) {
    .calendar-filter-body {
        padding: 1rem;
    }

    .calendar-filter-grid {
        grid-template-columns: 1fr;
    }

    .calendar-filter-action {
        width: 100%;
    }
}

@media (max-width: 767px) {
    .calendar-filter-surface {
        padding: 1rem 0.9rem 1rem 1.15rem;
    }

    .calendar-filter-label {
        font-size: 0.9rem;
    }

    .calendar-filter-head {
        padding: 0.8rem 1rem;
        font-size: 0.95rem;
    }
}
</style>
